// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"r3-z","colorTextValue":"s3-z","swatches":"t3-z","collapseLink":"u3-z","isCollapsed":"v3-z","dropdown":"w3-z","disabled":"x3-z"};